import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./Header.module.scss";
//import logo from "../assets/logo.svg";
import logo from "../assets/fansLogo.png";
import caret from "../assets/caret.svg";
import Button from "app/components/button/button";
import { useWallet } from "app/Loop_Reuseable_Component/packages/loop_wallet";
import { DefaultAvatar } from "app/core/common";
import { useHook } from "app/hooks/common";
import { Trans } from "react-i18next";
import { DirectusImage } from "../app/core/common";
import { truncate } from "app/helpers/helper";
import { useLogin } from "app/context/loginProvider";
import { RiExternalLinkLine } from "react-icons/ri";

type HeaderProps = {
  noheader: boolean;
};

export default function Header({ noheader }: HeaderProps) {
  const { logout } = useWallet();
  const { userInfo } = useHook();
  const location = useLocation();
  const [notiDrawer, setNotiDrawer] = useState(false);
  const [searchDrawer, setSearchDrawer] = useState(false);

  const { showSignup, toggleLoginModal, toggleSignupModal } = useLogin();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const origin = window.location.origin;
  const pathname = window.location.pathname;

  {
    /* add more actions here... */
  }
  const actions = [
    {
      name: <Trans>profile</Trans>,
      to: `https://app.loop.fans/user/${userInfo?.username ?? userInfo?.id}/`,
    },
  ];

  return (
    <>
      <div className={styles.header}>
        <div className="container">
          <div className={styles.items}>
            <div className={styles.left}>
              <div className={styles.logo_section}>
                <div className={styles.logo}>
                  <Link to="/">
                    <img src={logo} className={styles.logo} alt="logo" />
                    {/* <span>FANS</span> */}
                  </Link>
                </div>
              </div>
              {noheader ? null : (
                <div>
                  <ul className={styles.nav}>
                    <li>
                      <a href="https://www.loop.fans" target="_blank">
                        <Trans>home</Trans>
                      </a>
                    </li>
                    <li>
                      <a href="https://awards.loop.fans/" target="_blank">
                        Music Awards
                      </a>
                    </li>
                    <li>
                      <a href="https://create.loop.fans/create" target="_blank">
                        AI Create
                      </a>
                    </li>
                    <li>
                      <a href="/">
                        Promo Hub
                      </a>
                    </li>
                    {/* <li><a href="https://www.loop.fans/clubs">VIP Clubs</a></li> */}
                  </ul>
                </div>
              )}
            </div>

            <div className={styles.right}>
              {/* {noheader ? null : (
                <div className={styles.actions}>
                  <LanguageSelector />
                </div>
              )} */}
              {noheader ? null : (
                <>
                  {userInfo ? (
                    <div
                      className={styles.profile}
                      style={
                        dropdownOpen ? { borderRadius: "25px 25px 0 0" } : {}
                      }
                      onClick={() => setDropdownOpen(!dropdownOpen)}
                    >
                      <img
                        src={
                          userInfo?.avatar
                            ? DirectusImage(userInfo?.avatar)
                            : DirectusImage(DefaultAvatar)
                        }
                        alt=""
                      />
                      <p>{truncate(userInfo?.display_name ?? userInfo?.first_name, 10, "...")}</p>

                      <div className={styles.dropdown}>
                        <img src={caret} />
                      </div>
                      {dropdownOpen && (
                        <div className={styles.dropdown_content}>
                          {actions.map((action) => {
                            return (
                              <>
                                <a
                                  href={action.to}
                                  onClick={() => setDropdownOpen(false)}
                                >
                                  {action.name}
                                </a>
                              </>
                            );
                          })}
                          <Link
                            to="#"
                            onClick={() => {
                              logout();
                              //window.Bugpilot.logout();
                              window.location.reload();
                            }}
                          >
                            Logout
                          </Link>
                        </div>
                      )}
                    </div>
                  ) : (
                    <>
                      {noheader ? null : (
                        <>
                          <Button
                            className={styles.loginButton}
                            onClick={() => {
                              toggleLoginModal();
                              toggleSignupModal(false);
                            }}
                          >
                            Login
                          </Button>
                          <Button
                            className={styles.signupButton}
                            onClick={() => {
                              toggleLoginModal();
                              toggleSignupModal(true);
                            }}
                          >
                            Join Now
                          </Button>
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
